import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { useMediaQuery, useTheme } from '@mui/material';

import { sideNavOpenAtom } from 'atoms/sideNavAtom';

// 狭幅（< md）では SideNav を自動的に畳み、広幅へ戻したら展開する（C3: 表示のみ・データ/操作は不変）。
// 効果は breakpoint を跨いだ時だけ反応するため、同一幅帯での手動開閉は保持される。
export const useAutoCollapseSideNav = (): void => {
    const theme = useTheme();
    const narrow = useMediaQuery(theme.breakpoints.down('md'));
    const setOpen = useSetAtom(sideNavOpenAtom);

    useEffect(() => {
        setOpen(!narrow);
    }, [narrow, setOpen]);
};
